import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCrossSmall = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M9.516 8.46A.701.701 0 0 0 9 8.25a.782.782 0 0 0-.54.21.782.782 0 0 0-.21.54c0 .203.07.375.21.516L10.946 12l-2.484 2.484A.701.701 0 0 0 8.25 15c0 .203.07.383.21.54.157.14.337.21.54.21s.375-.07.516-.21L12 13.054l2.484 2.484c.141.14.313.211.516.211s.383-.07.54-.21a.782.782 0 0 0 .21-.54.701.701 0 0 0-.21-.516L13.054 12l2.484-2.484c.14-.141.211-.313.211-.516a.782.782 0 0 0-.21-.54.782.782 0 0 0-.54-.21.701.701 0 0 0-.516.21L12 10.946 9.516 8.461z" }),
});

export { IconCrossSmall };
